import {Link, useNavigate} from "react-router-dom";
import closeIcon from "../assets/icons/close-dark.png";
import logoLeft from "../assets/images/logo-left.png";
import chevronIcon from '../assets/icons/chevron-right.png';
import searchIcon from "../assets/icons/search-dark.png";
import React, {useState} from "react";

function MenuLink({children, to, target = '_self', onClick}: any) {
    return <Link to={to} target={target} className={`flex justify-between items-center p-4 bg-white`} onClick={() => onClick()}>
        {children}
        <img src={chevronIcon} width={7} height={12} alt="Right arrow icon" />
    </Link>
}

function Menu({onClose}: any) {
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    function searchHandler() {
        onClose();
        navigate(`/sok?query=${search}`)
    }

    return (
        <nav className="fixed top-0 left-0 w-full h-full bg-grey-200 overflow-auto">
            <div className="w-full flex justify-between items-center px-4 py-2 xl:px-8 xl:py-4 bg-white shadow-[0_2px_4px_rgba(0,0,0,0.40)]">
                <button className="cursor-pointer" onClick={() => onClose()}>
                    <div className={`w-[125px] h-[60px]`}>
                        <img src={logoLeft} alt="Sveriges Ingenjörer logotype"/>
                    </div>
                </button>
                <button className="cursor-pointer" onClick={() => onClose()}>
                    <img src={closeIcon} alt="Menu" width="30" height="30"/>
                </button>
            </div>

            <div className="px-4 xl:py-4 xl:mx-auto xl:w-auto xl:max-w-[60rem]">
                <div className="relative mt-6 mb-3">
                    <form onSubmit={searchHandler}>
                        <input type="text" placeholder="Sök" value={search} onChange={(e) => setSearch(e.target.value)}
                               className="w-full ps-4 pe-12 py-3 rounded-full font-body text-lg bg-grey-300 text-grey-900 focus:outline-none"/>
                        <button type="submit" className="absolute z-10 top-1/2 -translate-y-1/2 right-4">
                            <img src={searchIcon} width={24} height={24} alt="Search"/>
                        </button>
                    </form>
                </div>

                <p className="font-body text-grey-900 text-[20px] py-3">Hitta på Ingenjörskompassen</p>

                <div className="flex flex-col gap-[1px] mb-6 rounded-lg overflow-hidden">
                    <MenuLink to="/sok/yrkesomraden" onClick={onClose}>Yrkesområde</MenuLink>
                    <MenuLink to="/sok/yrkeskategorier" onClick={onClose}>Yrkeskategori</MenuLink>
                    <MenuLink to="/sok/yrken" onClick={onClose}>Yrken</MenuLink>
                </div>

                <div className="flex flex-col gap-[1px] mb-6 rounded-lg overflow-hidden">
                    <MenuLink to="/om-tjansten" onClick={onClose}>Om tjänsten</MenuLink>
                    <MenuLink to="/kontakt" onClick={onClose}>Kontakta oss</MenuLink>
                    <MenuLink to="https://www.sverigesingenjorer.se/allmant/gdpr/" target="_blank" onClick={onClose}>Privacy
                        policy</MenuLink>
                </div>

                <p className="font-body text-grey-900 text-sm py-3">Ingenjörskompassen är en del av Sveriges
                    Ingenjörer</p>

                <div className="flex flex-col gap-[1px] mb-6 rounded-lg overflow-hidden">
                    <MenuLink to="https://www.sverigesingenjorer.se/" target="_blank" onClick={onClose}>
                        <img src={logoLeft} width={125} height={60} alt="Sveriges Ingenjörer"/>
                    </MenuLink>
                </div>
            </div>
        </nav>
    );
}

export default Menu;